import React from 'react';
import { Button } from '@/components/ui/button';
import { MapPin, Check } from 'lucide-react';

interface LocationSuggestionBannerProps {
  suggestedCity: string;
  suggestedState: string;   // Código ISO (ex: "SP")
  suggestedCountry: string; // Código ISO (ex: "BR")
  onAccept: () => void;
  isAccepted: boolean;
}

const LocationSuggestionBanner: React.FC<LocationSuggestionBannerProps> = ({
  suggestedCity,
  suggestedState,
  suggestedCountry,
  onAccept,
  isAccepted
}) => {
  if (!suggestedCity && !suggestedState) return null;

  // Formato: "Cidade, ISO-Estado, ISO-País" (ex: "São Paulo, SP, BR")
  const locationText = [suggestedCity, suggestedState, suggestedCountry].filter(Boolean).join(', ');

  return (
    <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg p-4">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-blue-500/20 rounded-full flex items-center justify-center flex-shrink-0">
          <MapPin className="h-5 w-5 text-blue-400" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-blue-400 font-medium">
            Localização detectada
          </p>
          <p className="text-white text-base truncate">
            {locationText}
          </p>
        </div>
        {!isAccepted ? (
          <Button
            onClick={onAccept}
            size="sm"
            className="bg-blue-500/20 hover:bg-blue-500/30 text-blue-400 border border-blue-500/30"
          >
            Usar
          </Button>
        ) : (
          <div className="w-8 h-8 bg-green-500/20 rounded-full flex items-center justify-center">
            <Check className="h-4 w-4 text-green-400" />
          </div>
        )}
      </div>
      <p className="text-xs text-white/50 mt-2">
        Você pode alterar os campos abaixo se preferir outra localização.
      </p>
    </div>
  );
};

export default LocationSuggestionBanner;
